import React, { useEffect, useState } from "react";
import "./question.css";
import { useSelector, useDispatch } from "react-redux";
import {
  getQuestions,
  getCurrentQuestion,
  saveAndNext,
  markAndNext,
} from "./../../features/Questions/questionSlice";
// import {Image,CloudinaryContext} from 'cloudinary-react';


import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  TextField
} from "@material-ui/core";

function Question({sendDataToParent}) {
  const currentQ = useSelector(getCurrentQuestion);
  const Questions = useSelector(getQuestions);
  const maxQ = Questions.length || 0;
  const [ans, setAns] = useState("");
  const dispatch = useDispatch();
  // const numericals = [21,22,23,24,25,46,47,48,49,50,71,72,73,74,75] 
  useEffect(() => {
    sendDataToParent(ans);
  }, [ans]);

// useEffect(() => {
//   if (maxQ){
//     setAns(Questions[0].attempted);
//     console.log("done", Questions[0].attempted);
//   }
// }, [maxQ])
  
useEffect(() => {
  setAns(maxQ ? Questions[currentQ - 1].attempted : "");
  // console.log(currentQ, Questions[currentQ - 1].attempted);
  }, [currentQ]);
  
  const Options = ({ a, b, c, d }) => {
    const handleChange = (event) => {
      setAns(event.target.value);
    };



    return (
      <FormControl component="fieldset" className="">
        <RadioGroup row value={ans} onChange={handleChange}>
          <FormControlLabel value="a" control={<Radio />} label={a} />
          <FormControlLabel value="b" control={<Radio />} label={b} />
          <FormControlLabel value="c" control={<Radio />} label={c} />
          <FormControlLabel value="d" control={<Radio />} label={d} />
        </RadioGroup>
      </FormControl>
    );
  };
  // console.log(Questions, currentQ);

  const QuestionCard = () => {
    // console.log(Questions);
    return (
      Questions && (
        <div className="question-card d-flex flex-column">
          <h3 className="">Question {Questions[currentQ - 1].id} : </h3>
          <img
            className="img-fluid"
            loading = 'eager'
            alt={"questions" + Questions[currentQ - 1].id}
            src = {Questions[currentQ - 1].src}
          />
          {maxQ && Questions[currentQ - 1].q_type === "num" && (
            <TextField
              label="Answer"
              type="number"
              style={{ width: "50%", marginTop: "20px" }}
              defaultValue={ans}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => setAns(e.target.value.toString())}
              variant="outlined"
            />
          )}
          {maxQ && Questions[currentQ - 1].q_type === 'mcq' && (
            <Options a={'a'} b={'b'} c={'c'} d={'d'} />
          )}
        </div>
      )
    );
  };

  const Buttons = () => {
    return (
      <>
        <button
          className="btn btn-success"
          onClick={(e) => {
            e.preventDefault();
            dispatch(saveAndNext(ans));
            setAns(Questions[currentQ - 1].attempted);
          }}
        >
          Save {"&"} Next
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={(e) => {
            e.preventDefault();
            dispatch(markAndNext(ans));
            setAns(Questions[currentQ - 1].attempted);
          }}
        >
          Mark for Review {"&"} Next
        </button>
        <button
          type="button"
          className="btn btn-light"
          onClick={() => {
            setAns("");
          }}
        >
          Clear Response
        </button>
      </>
    );
  };

  return (
    maxQ && (
      <>
        <QuestionCard />
        <Buttons />
      </>
    )
  );
}

export default Question;
